// src/service/surveys.js
export default class SurveysService {
  constructor(http) {
    this.http = http;
  }

  async findAllSurveys(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/surveys/readall?${queryParams}`, {
      method: "GET",
    });
  }

  async createSurvey(surveyData) {
    return this.http.fetch(`/api/surveys/create`, {
      method: "POST",
      body: JSON.stringify(surveyData),
    });
  }

  async updateSurvey(surveyData) {
    return this.http.fetch(`/api/surveys/update`, {
      method: "PUT",
      body: JSON.stringify(surveyData),
    });
  }

  async deleteSurvey(id) {
    return this.http.fetch(`/api/surveys/delete`, {
      method: "DELETE",
      body: JSON.stringify({ id }),
    });
  }

  // 설문 공개 상태 변경
  async createOrUpdateSurveySubjectLink(data) {
    return this.http.fetch("/api/surveysubjectlinks/createorupdate", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}
